export const availableAnimations = [
    "none",
    "fade",
    "fade-up",
    "fade-down",
    "fade-left",
    "fade-right",
    "flip-up",
    "flip-down",
    "flip-left",
    "flip-right",
    "zoom-in",
    "zoom-out",
];